import React, { useRef } from 'react';
import PropTypes from 'prop-types';

import DefaultButton from '../default-btn/DefaultButton';
import './FileInput.scss';

const FileInput = ({ handleFileSelect, locKey, multiple, disabled, ...props }) => {
  const fileInput = useRef();

  const onFileSelected = () => {
    const files = fileInput.current.files;
    if (files.length > 0) {
      handleFileSelect(multiple ? Array.from(files) : files[0]);
    }
    fileInput.current.value = null;
  };

  const initFileInput = () => {
    if (disabled) return;
    fileInput.current?.click();
  };

  return (
    <div className="file-input-wrapper">
      <DefaultButton locKey={locKey} onClick={initFileInput} className="qau-file-input" disabled={disabled} />
      <input
        type="file"
        ref={fileInput}
        name="file-upload"
        data-testid="file-upload-input"
        onChange={onFileSelected}
        tabIndex={-1}
        aria-hidden="true"
        multiple={multiple}
        disabled={disabled}
        {...props}
      />
    </div>
  );
};

FileInput.propTypes = {
  locKey: PropTypes.string,
  handleFileSelect: PropTypes.func.isRequired,
  multiple: PropTypes.bool,
};

export default FileInput;
